import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { styles } from "components/molecules/Input/Input.styles";

export const StyledDateRange = styled(DatePicker)`
  ${styles}
  padding-left: ${({ prefix }) => prefix && "2.5rem"};
  padding-right: ${({ $suffix }) => {
    if ($suffix) return "2.5rem";
    return "2rem";
  }};
`;
export const StyledDateRangeWrap=styled.div`
width: 100%;
label{
  display: block;
  margin-bottom: 10px;
  font-size: 16px; 
  line-height: 20px; 
  font-weight: 600;
}
`;
export const ButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
`;
